/**
 * Procentul de esantionare al SDK-ului din browser, din `VITE_APPINSIGHTS_SAMPLING_PERCENTAGE`.
 *
 * Trebuie sa fie ACELASI cu al backendului (`APPLICATIONINSIGHTS_SAMPLING_PERCENTAGE` pe App
 * Service): SDK-urile decid dupa id-ul operatiei, deci la procente egale se pastreaza lanturi
 * intregi browser → backend; la procente diferite, lanturile se rup (masurat 2026-09-21: 100% aici
 * si 50% pe backend dadeau doar 52% din AJAX cu request legat).
 *
 * Variabila e inline-uita la BUILD. Lipsa sau o valoare invalida → 100, ca o greseala de config sa
 * nu stinga telemetria tacut.
 */
export function parseSamplingPercentage(raw: string | undefined): number {
    if (raw === undefined || raw.trim() === "") return 100;
    const value = Number(raw);
    if (!Number.isFinite(value) || value <= 0 || value > 100) return 100;
    return value;
}
